import React, { FC, useEffect, useMemo } from 'react'
import { FieldErrors } from 'react-hook-form'
import ControlledSelect, { IControlledSelectProps } from 'transfix-form/components/ControlledSelect'
import { useDispatcherApi } from 'apps/fleet-planner/hooks'
import { TRateConfirmationFormSchema } from './components/RateConfirmationForm/schema/RateConfirmationFormSchema'
import { TInputRefType } from './components/RateConfirmationForm/types'

export interface IDispatcherSelect extends Pick<IControlledSelectProps, 'control' | 'SelectProps'> {
  motorCarrierId?: number
  formErrors: FieldErrors<TRateConfirmationFormSchema>
  inputRef?: TInputRefType['dispatcherId']
}

export const DispatcherSelect: FC<IDispatcherSelect> = ({
  SelectProps = {},
  formErrors,
  control,
  motorCarrierId,
  inputRef,
}) => {
  const { getDispatchers, dispatchers = [] } = useDispatcherApi()
  const dispatchersOptions = useMemo(
    () =>
      dispatchers.map(d => ({
        value: d.id.toString(),
        label: d.fullName || '',
      })),
    [dispatchers]
  )

  useEffect(() => {
    if (motorCarrierId) {
      getDispatchers({ motorCarrierId })
    }
  }, [motorCarrierId, getDispatchers])

  return (
    <ControlledSelect
      control={control}
      name='dispatcherId'
      SelectProps={{
        large: true,
        options: dispatchersOptions,
        label: 'Select a dispatcher',
        required: true,
        error: !!formErrors?.dispatcherId?.message,
        validationMessage: formErrors?.dispatcherId?.message,
        inputRef,
        ...SelectProps,
      }}
    />
  )
}
